/* eslint-disable no-return-await */
import {BACKEND} from '../../consts/backend';
import HttpClient from '../helpers/providers.helper';
import axios from 'axios';

class FileProvider {
  httpClient = HttpClient;

 /* async submitFiles1(file, orderNumber) {
    const formData = new FormData();
    formData.append('file', file);
    return await this.httpClient.post(
      `${BACKEND}/order/${orderNumber}/file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
 
  }*/
  
  async submitFiles(file, orderNumber) {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${BACKEND}/order/${orderNumber}/file`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Respuesta del servidor al subir archivos:', data);
    return data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
  }


  async getFiles(orderNumber) {
    return await this.httpClient.get(
      `${BACKEND}/order/${orderNumber}/files`
    );
  }

  async getDispatchFiles(dispatchNumber) {
    return await this.httpClient.get(
      `${BACKEND}/order/${dispatchNumber}/files_dispatch`
    );
  }
}

export default FileProvider;
